/**
 * Global font class name for Layout. Uses CSS from styles/fonts.css (@font-face for Lato/Montserrat).
 * We do not use next/font here because Turbopack has a known bug with next/font in the Pages Router
 * (https://github.com/vercel/next.js/issues/86792).
 */
export const fontClassnamesGlobal = 'font-app-global';
